<template>
  <div>
    <span>{{ displayTime }}</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      time: 180, // 3분(180초)으로 초기화
      timerId: null
    }
  },
  computed: {
    displayTime () {
      const minutes = Math.floor(this.time / 60)
        .toString()
        .padStart(2, '0')
      const seconds = (this.time % 60).toString().padStart(2, '0')
      return `${minutes}:${seconds}`
    }
  },
  methods: {
    startTimer () {
      if (!this.timerId) {
        this.timerId = setInterval(() => {
          this.time--
          if (this.time === 0) {
            this.resetTimer()
            this.emitStopTimer()
          }
        }, 1000)
      }
    },
    stopTimer () {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = null
      }
    },
    resetTimer () {
      this.stopTimer()
      this.time = 5 // 3분(180초)으로 초기화
    },
    emitStopTimer () {
      this.$emit('emitStopTimer')
    }
  }
}
</script>
